type CookieEndDate = number | string | Date

export const Cookies = {
  getItem: (key: string): string | undefined => {
    if (!key || !Cookies.hasItem(key)) {
      return undefined
    }

    const encodedKeyPattern = new RegExp(
      '(?:^|.*;\\s*)' +
        encodeURIComponent(key).replaceAll(/[*+.-]/g, '\\$&') +
        '\\s*=\\s*([^;]*).*$'
    )

    return decodeURIComponent(document.cookie.replace(encodedKeyPattern, '$1'))
  },

  setItem: (
    key: string,
    value: string,
    endDate?: CookieEndDate,
    path?: string,
    domain?: string,
    isSecured?: boolean,
    isSameSite = true
  ): void => {
    if (!key || /^(?:expires|max-age|path|domain|secure)$/.test(key)) {
      return
    }

    let expiration = ''
    if (endDate) {
      switch (typeof endDate) {
        case 'number': {
          expiration = `; max-age=${endDate}`
          break
        }
        case 'string': {
          expiration = `; expires=${endDate}`
          break
        }
        case 'object': {
          if (endDate instanceof Date) {
            expiration = `; expires=${endDate.toUTCString()}`
          }
          break
        }
        // No default
      }
    }

    // eslint-disable-next-line unicorn/no-document-cookie
    document.cookie =
      `${encodeURIComponent(key)}=${encodeURIComponent(value)}` +
      expiration +
      (domain ? `; domain=${domain}` : '') +
      (path ? `; path=${path}` : '') +
      (isSecured ? '; secure' : '') +
      (isSameSite ? '' : '; SameSite=None; secure')
  },

  removeItem: (key: string): void => {
    if (!key || !Cookies.hasItem(key)) {
      return
    }

    const expirationDate = new Date()
    expirationDate.setDate(expirationDate.getDate() - 1)
    // eslint-disable-next-line unicorn/no-document-cookie
    document.cookie = `${encodeURIComponent(key)}=; expires=${expirationDate.toUTCString()}; path=/`
  },

  hasItem: (key: string): boolean =>
    new RegExp(
      '(?:^|;\\s*)' +
        encodeURIComponent(key).replaceAll(/[*+.-]/g, '\\$&') +
        '\\s*='
    ).test(document.cookie),
}

const ACCESS_TOKEN_KEY = 'accessToken'

export function getCookie(name: string): string | undefined {
  return Cookies.getItem(name)
}

export function getAccessToken(): string | undefined {
  return Cookies.getItem(ACCESS_TOKEN_KEY)
}

export function setAccessToken(token: string): void {
  Cookies.setItem(ACCESS_TOKEN_KEY, token, 60 * 60)
}

export function removeAccessToken(): void {
  Cookies.removeItem(ACCESS_TOKEN_KEY)
}
